import { Box, IconButton, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { RiErrorWarningLine } from 'react-icons/ri';
import StyledBox from 'views/rebranded-module/common/components/UI/NewMainWidget/WidgetNotificationBox/WidgetNotificationBox.styles';


// ✅ Props interface
interface WidgetNotificationBoxProps {
  notificationsList?: string[];
  title?: string;
}

const WidgetNotificationBox: React.FC<WidgetNotificationBoxProps> = React.memo(
  ({ notificationsList, title }) => {
    const [openError, setOpenError] = useState<boolean>(false);

    const handleCloseErrorClick = () => setOpenError(false);

    useEffect(() => {
      setOpenError(!!notificationsList && notificationsList.length > 0);
    }, [notificationsList]);

    return (
      <>
        {openError && notificationsList && (
          <StyledBox>
            <Box className="WBEIcon">
              <RiErrorWarningLine />
            </Box>
            <Box sx={{ flex: 1 }}>
              {title && (
                <Typography className="WBEsmallFontSize">{title}</Typography>
              )}
              {notificationsList.map((baseError, idx) => (
                <Typography key={`${baseError}-${idx}`} className="WBEsmallFontSize">
                  {title && (
                    <Typography className="WBEsmallFontSize" component="span">
                      &gt;{' '}
                    </Typography>
                  )}
                  <Typography
                    component="span"
                    className="WBEsmallFontSize"
                    dangerouslySetInnerHTML={{
                      __html: baseError,
                    }}
                  />
                </Typography>
              ))}
            </Box>
            <IconButton
              className="WBECloseButton"
              onClick={handleCloseErrorClick}
            >
              <CloseIcon />
            </IconButton>
          </StyledBox>
        )}
      </>
    );
  }
);

export { WidgetNotificationBox };
